<!--
 * @Author: Zhongnanwei
 * @Date: 2021-08-11 18:01:12
 * @LastEditors: longtuxin
 * @LastEditTime: 2022-08-19 17:03:24
 * @Description:
-->
<template>
  <div class="page">
    <table>
      <tr>
        <th>区域</th>
        <th>企业类型</th>
        <th>用户名</th>
        <th>电话号码</th>
        <th>体验产品</th>
        <th>来源</th>
        <th>留言时间</th>
      </tr>
      <tr v-for="td of table" :key="td.id">
        <td>{{ td.areaName }}</td>
        <td>{{ td.userType | toType }}</td>
        <td>{{ td.userName }}</td>
        <td>{{ td.mobile }}</td>
        <td>{{ td.product }}</td>
        <td>{{ feedbackTypeMap[td.feedbackType] || '未知' }}</td>
        <td>{{ td.createTime | toTime }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import Contant from '../const/index.js'
import { parseTime } from '../utils'
export default {
  components: {},
  data() {
    return {
      table: [],
      feedbackTypeMap: {
        1: '官网',
        2: '430托管学堂',
      },
    }
  },
  created() {
    this.$axios
      .post('/core2/nzp-core-contact-server/rest/fbck/feedback/query_feedback_list', {})
      .then((res) => {
        const { data } = res
        this.table = data.data.list
      })
      .catch((err) => {
        console.error(err)
      })
  },
  filters: {
    toTime(val) {
      return parseTime(val)
    },
    toType(val) {
      console.log('this.Option', Contant.userType)
      return Contant.userType.find((it) => it.value == val)?.label || '--'
    },
  },
}
</script>

<style scoped lang="less">
.border {
  border: 1px solid;
}
table {
  .border;
  width: 100%;
  margin: 0 auto;

  tr {
    line-height: 32px;
  }

  th,
  td {
    .border;
    text-align: center;
  }
}
</style>
